import { Controller } from "@hotwired/stimulus"

// AT-495: aftellen tot het winkelmandje verloopt.
//
// De deadline komt van de server (cart.created_at + Cart::EXPIRE_TIMEOUT) en staat als
// ISO-tijd in een data-attribuut. Deze controller toont alleen; de server bepaalt of
// een mandje daadwerkelijk verlopen is. Zonder JS blijft de servertekst met het tijdstip
// staan, wat op zichzelf al bruikbaar is.
export default class extends Controller {
  static targets = ["text"]
  static values = { deadline: String, expiredMessage: String }

  connect() {
    this.deadline = new Date(this.deadlineValue)
    this.#tick()
    this.timer = setInterval(() => this.#tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  #tick() {
    const remaining = Math.floor((this.deadline - new Date()) / 1000)

    if (remaining <= 0) {
      this.textTarget.textContent = this.expiredMessageValue
      this.element.classList.add("is-expired")
      clearInterval(this.timer)
      return
    }

    const minutes = Math.floor(remaining / 60)
    const seconds = remaining % 60

    this.textTarget.textContent =
      this.textTarget.dataset.countdownTemplate.replace(
        "%{time}",
        `${minutes}:${String(seconds).padStart(2, "0")}`
      )

    // Laatste vijf minuten opvallender maken.
    this.element.classList.toggle("is-urgent", remaining <= 300)
  }
}
